// DISCLIMER: players.js cannot be loaded twice, please prevent to be loaded in head bundle, it would cause issues

/* eslint-disable no-case-declarations */
// There are some comments with tags explaining the situation in the code.
// You can find them by following names:

// @ONHOLD - waiting
// @TODO

// ---------------------------------------
// player service
// facade between player instances and application

// ---------------------------------------

import {
	createParent,
	events,
	commands,
	gemius,
	getPersistentConfig,
	vastDebug,
} from '@efabrica/player/parent/lib'
import Utils from 'nova-tn-frontend/source/scripts/modules/Utils'

const PageData = window.PageData || {}
const {
	ai_content = false,
	articleTopics = null,
	categories = null,
	contentOrigin = null,
	contentAuthor = null,
	contentID = null,
	contentLastUpdate = null,
	contentPublishDate = null,
	contentSeasonNumber = null,
	contentSeasonTitle = null,
	contentShowID = null,
	contentShowTitle = null,
	contentTitle = null,
	contentType = null,
} = PageData
let mid = getMid()

const viewId = window.sasTracker?.viewId
if (!viewId) {
	// eslint-disable-next-line no-console
	console.error(
		'SAS: sasTracker script must precedence players script, SAS ads tracking will not work'
	)
}

const plugins = [events({ legacy: true }), commands(), vastDebug()]

if (window.GemiusPlayer !== null) {
	console.log('player: gemius plugin already loaded, skipping')
} else {
	plugins.push(
		gemius({
			newProgram: (sourceInfo) => {
				const playerState =
					playerEmbedsController.players?.get(sourceInfo.id) || {}
				return {
					ai_content,
					articleTopics,
					categories,
					contentOrigin,
					contentAuthor,
					contentID,
					contentLastUpdate,
					contentPublishDate,
					contentSeasonNumber,
					contentSeasonTitle,
					contentShowID,
					contentShowTitle,
					contentTitle,
					contentType,
					contentDistributionType: sourceInfo.isLive ? 'live' : 'vod',
					customAttributes: JSON.stringify({
						currentDomain: window.location.host,
						volume: playerState.volume,
						resolution:
							playerState.width + 'x' + playerState.height,
					}),
					customAttribute1: playerState.playerType,
				}
			},
		})
	)
}

const playerEmbedsController = createParent(
	{
		// on creation of local player state
		onCreation: (iframe, playerID /* message */) => {
			const isMiniplayer =
				iframe.closest('.miniplayer') ||
				iframe.id === 'miniplayer-iframe'
			let playerState = {
				playerType: isMiniplayer ? 'miniplayer' : 'bigPlayer',
				// skip gtm, gemius and nielsen tracking for players in hero component
				skipTracking:
					iframe.closest('.skip-tracking-player') !== null ||
					iframe.closest('.c-hero-wrap') !== null ||
					iframe.closest('.videos-page__highlight') !== null ||
					iframe.closest('.js-tnlive-homepage-box') !== null,
			}
			if (!isMiniplayer) {
				Object.assign(playerState, {
					usePersistentConfig: iframe.classList.contains(
						'js-player-container'
					)
						? 'general'
						: false,
				})
			}

			window.KEventsAdditionalData = window.KEventsAdditionalData || {}
			const KEventsData = window.KEventsAdditionalData[playerID] || {}
			KEventsData.playerType = playerState.playerType
			window.KEventsAdditionalData[playerID] = KEventsData

			return playerState
		},
		// change of remote player configuration
		onConnection: (playerState) => {
			mid = mid || getMid()
			return {
				ui: {
					timeouts: {
						hideSourceAfter: Utils.isBlockedBySeznam()
							? Infinity
							: 10000,
					},
				},
				plugins: {
					ads: {
						customReplacements: {
							'###LAYOUT###': window.matchMedia(
								'(max-width: 991px)'
							).matches
								? 'mobile'
								: 'desktop',
							'###VIEW_ID###': viewId || 'unknown',
						},
						customParams: {
							mid,
						},
					},
					...(playerState.skipTracking
						? {
								gemius: null,
								nielsen: null,
								events: {
									customData: { skipGTM: true },
								},
						}
						: {}),
					...(getPersistentConfig(playerState.usePersistentConfig) ||
						{}),
				},
			}
		},
		// return truthy if you want to force pause, falsy if you want to skip pausing
		resolvePausing(playerState, initiatorPlayerState) {
			// Live player has exception from pausing logic if its in RTE
			const playerIsInRte = $(
				'[data-video-id="' + playerState.id + '"]'
			).closest('.c-rte')

			return (
				(playerIsInRte ||
					playerState.type !== 'live' ||
					initiatorPlayerState.type !== 'live') &&
				!pauseExceptions.has(playerState.id)
			)
		},
	},
	plugins
)

function getMid() {
	let midTmp = null
	document.cookie.split(';').forEach((cookie) => {
		const [name, value] = cookie.split('=')
		if (name.trim() === '__sas_mid') {
			midTmp = value
		}
	})
	return midTmp
}

export const pauseExceptions = new Set()
export const toggleMute = playerEmbedsController.toggleMute
export const toggleCinema = playerEmbedsController.toggleCinema
export const toggleFullscreen = playerEmbedsController.toggleFullscreen
export const play = playerEmbedsController.play
export const pause = playerEmbedsController.pause
export const register = playerEmbedsController.register
